import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const stored = sessionStorage.getItem('piano-countdown-end');
    if (stored) {
      const diff = Math.max(0, Math.floor((parseInt(stored) - Date.now()) / 1000));
      return diff;
    }
    const endTime = Date.now() + 2 * 60 * 60 * 1000;
    sessionStorage.setItem('piano-countdown-end', endTime.toString());
    return 2 * 60 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="bg-navy-lighter border-b border-gold/20 text-beige py-2 px-4 text-center text-sm font-medium flex items-center justify-center gap-2" data-id="element-312">
      <Clock className="w-4 h-4 text-gold" data-id="element-313" />
      <span className="text-beige/80" data-id="element-314">Oferta termina en</span>
      <span className="font-mono font-bold text-gold tracking-wider" data-id="element-315">
        {pad(hours)}:{pad(minutes)}:{pad(seconds)}
      </span>
    </div>;
}